import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconKeyframe"><Path d="M13.7675 2.56084C12.7912 1.58454 11.2082 1.58454 10.2319 2.56084L2.56036 10.2324C1.58405 11.2087 1.58405 12.7916 2.56035 13.7679L10.2319 21.4395C11.2082 22.4158 12.7912 22.4158 13.7675 21.4395L21.439 13.7679C22.4153 12.7916 22.4153 11.2087 21.439 10.2324L13.7675 2.56084Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
